import React from 'react'
import { useNavigate } from 'react-router-dom'

export const ClinicsList = () => {
    return (
        <div className='flex flex-col gap-3 max-h-[80vh] overflow-scroll my-10 overflow-x-hidden '>
            <Clinic />
            <Clinic />
            <Clinic />
            <Clinic />
            <Clinic />
            <Clinic />
            <Clinic />
            <Clinic />
            <Clinic />
            <Clinic />
        </div>
    )
}


const Clinic = () => {
    const navigate = useNavigate()
    return (
        <div className='flex px-5 py-2 items-center bg-white rounded-lg cursor-pointer' onClick={() => navigate('1')}>
            <div className='rounded-full bg-blue-500 p-5'>

            </div>
            <h1 className='font-bold text-lg ps-5'>
                CLINIC 1
            </h1>
        </div>
    )
}
